import { cn } from "@/lib/utils"
import { ArrowRightIcon, AlertCircleIcon, UsersIcon } from "lucide-react"

interface StartupSummaryCardProps {
  painPointsCount?: number
  interviewsCount?: number
  viewHref?: string
  className?: string
}

export function StartupSummaryCard({
  painPointsCount = 0,
  interviewsCount = 0,
  viewHref = "/founder/startup",
  className,
}: StartupSummaryCardProps) {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-lg p-6 space-y-6",
        className
      )}
    >
      {/* Header */}
      <div>
        <h3 className="text-lg font-semibold text-foreground">
          My Startup Summary
        </h3>
      </div>

      {/* Metrics */}
      <div className="space-y-4">
        {/* Pain Points */}
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <AlertCircleIcon className="h-6 w-6 text-primary" />
          </div>
          <div className="flex-1">
            <div className="text-2xl font-bold text-foreground">
              {painPointsCount}
            </div>
            <div className="text-sm text-muted-foreground">
              Pain Points Identified
            </div>
          </div>
        </div>

        {/* Interviews */}
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <UsersIcon className="h-6 w-6 text-primary" />
          </div>
          <div className="flex-1">
            <div className="text-2xl font-bold text-foreground">
              {interviewsCount}
            </div>
            <div className="text-sm text-muted-foreground">
              Interviews Logged
            </div>
          </div>
        </div>
      </div>

      {/* View Link */}
      <a
        href={viewHref}
        className="flex items-center justify-between px-4 py-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors group"
      >
        <span className="text-sm font-medium text-foreground">
          View My Startup
        </span>
        <ArrowRightIcon className="h-4 w-4 text-muted-foreground group-hover:text-foreground group-hover:translate-x-1 transition-all" />
      </a>
    </div>
  )
}
